import { getNavIconUrls } from './config/publicIcons.config'

const navUrls = getNavIconUrls()

/** Stable public URL for team icon (used in profile, modals, Milemarker). */
export const teamIcon = navUrls.team

export const logIcon = navUrls.log
export const logIconSecondary = navUrls.logSecondary

export enum ScreenPath {
  home = '/',
  login = '/login',
  signup = '/signup',
  log = '/log',
  team = '/team',
  challenges = '/challenges',
  leaderboard = '/leaderboard',
  profile = '/profile',
  chat = '/chat',
  map = '/map',
  gate = '/gate',
  forgotPassword = '/forgot-password',
  resetPassword = '/reset-password',
}

export function profilePath(userID?: string) {
  return userID ? `${ScreenPath.profile}/${userID}` : ScreenPath.profile
}

/** Challenge-scoped onboarding / join funnel. Route id is read by useChallengeId() while present. */
export function challengeTeamPath(challengeId: string) {
  return `${ScreenPath.challenges}/${challengeId}/team`
}

export function challengeTeamCreatePath(challengeId: string) {
  return `${challengeTeamPath(challengeId)}/create`
}

export function challengeTeamJoinPath(challengeId: string) {
  return `${challengeTeamPath(challengeId)}/join`
}

export function challengeTeamFreeAgentPath(challengeId: string) {
  return `${challengeTeamPath(challengeId)}/free-agent`
}

export function challengePaymentIntroPath(challengeId: string) {
  return `${ScreenPath.challenges}/${challengeId}/payment/intro`
}

export function challengePaymentSuccessPath(challengeId: string) {
  return `${ScreenPath.challenges}/${challengeId}/payment/success`
}
